<template>
    <v-menu
        :offset-x="offsetX"
        :offset-y="offsetY"
        :nudge-top="nudgeTop"
        :right="right"
        :min-width="minWidth"
        :close-on-content-click="closeOnContentClick"
        :disabled="disabled">
        <template v-slot:activator="{ on, attrs }">
            <slot name="activator" :on="on" :attrs="attrs" :disabled="disabled"></slot>
        </template>
        <v-list dense nav>
            <v-list-item :disabled="disabled" @click="$emit('select', 'account')">
                <v-list-item-icon>
                    <v-icon>mdi-account-box-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="mr-5">Account</v-list-item-title>
            </v-list-item>
            <v-list-item :disabled="disabled" @click="$emit('select', 'wallet')">
                <v-list-item-icon>
                    <v-icon>mdi-wallet-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="mr-5">Wallet</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: 'PoolCreateMenu',
    props: {
        closeOnContentClick: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        minWidth: {
            type: [Number, String],
            default: undefined
        },
        nudgeTop: {
            type: [Number, String],
            default: undefined
        },
        offsetX: {
            type: Boolean,
            default: false
        },
        offsetY: {
            type: Boolean,
            default: false
        },
        right: {
            type: Boolean,
            default: false
        }
    }
}
</script>
